import { render } from "./CustomCtaButton.vue?vue&type=template&id=0072a3f5&scoped=true"
import script from "./CustomCtaButton.vue?vue&type=script&lang=js"
export * from "./CustomCtaButton.vue?vue&type=script&lang=js"

import "./CustomCtaButton.vue?vue&type=style&index=0&id=0072a3f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0072a3f5"]])

export default __exports__